import { StateCreator } from 'zustand';

import { TwinData } from '@/types';

export interface ChatSettings {
  wordLimit: number;
  setWordLimit: (wordLimit: number) => void;
  language: string;
  setLanguage: (language: string) => void;
  audio: Blob | null;
  setAudio: (audio: Blob | null) => void;
  category: Record<string, any> | null;
  setCategory: (category: Record<string, any> | null) => void;
  audioEnabled: boolean;
  setAudioEnabled: (audioEnabled: boolean) => void;
  messages: any[];
  addMessage: (message: { id: string; sender: string; message: string }) => void;
  updateMessages: (messages: any[]) => void;
  updateMessageAudio: (messageId: string, audioUrl: string) => void;
  setMessages: (messages: any[] | ((prevMessages: any[]) => any[])) => void;
  deleteMessages: () => void;
  isChatHistoryLoaded: boolean;
  setIsChatHistoryLoaded: (loaded: boolean) => void;
  isChatHistoryLoading: boolean;
  setIsChatHistoryLoading: (loading: boolean) => void;
  chatInputFocused: boolean;
  setChatInputFocused: (focused: boolean) => void;
  chatMode: 'text' | 'video';
  setChatMode: (mode: 'text' | 'video') => void;

  isScrolled: boolean;
  setIsScrolled: (isScrolled: boolean) => void;
}

export interface TwinSlice {
  twin: TwinData;
  setTwin: (chat: TwinData | null) => void;
}

export const chatSettings: StateCreator<ChatSettings> = (set) => ({
  wordLimit: 50,
  setWordLimit: (wordLimit: number) => {
    set(() => ({ wordLimit }));
  },
  language: 'en',
  setLanguage: (language: string) => {
    set(() => ({ language }));
  },
  audio: null,
  setAudio: (audio: Blob | null) => {
    set(() => ({ audio }));
  },
  category: null,
  setCategory: (category: Record<string, any> | null) => {
    set(() => ({ category }));
  },
  audioEnabled: true,
  setAudioEnabled: (audioEnabled: boolean) => {
    set(() => ({ audioEnabled }));
  },
  addMessage: (message: { id: string; sender: string; message: string }) => {
    set((state) => ({ messages: [...state.messages, message] }));
  },
  messages: [],
  updateMessages: (messages: any[]) => {
    set((state) => ({ messages: [...state.messages, ...messages] }));
  },

  updateMessageAudio: (messageId: string, audioUrl: string) => {
    set((state) => ({
      messages: state.messages.map((message) =>
        message.id === messageId
          ? { ...message, audioUrl }
          : message
      ),
    }));
  },
  setMessages: (messages: any[] | ((prevMessages: any[]) => any[])) => {
    set((state) => ({
      messages:
        typeof messages === 'function' ? messages(state.messages) : messages,
    }));
  },
  deleteMessages: () => {
    set(() => ({ messages: [] }));
  },
  isChatHistoryLoaded: false,
  setIsChatHistoryLoaded: (loaded: boolean) => {
    set(() => ({ isChatHistoryLoaded: loaded }));
  },
   isChatHistoryLoading: false,
  setIsChatHistoryLoading: (loading: boolean) => {
    set(() => ({ isChatHistoryLoading: loading }));
  },
  chatInputFocused: false,
  setChatInputFocused: (focused: boolean) => {
    set(() => ({ chatInputFocused: focused }));
  },
  chatMode: 'text',
  setChatMode: (mode: 'text' | 'video') => {
    set(() => ({ chatMode: mode }));
  },

  streamState: 'done',
  isScrolled: false,
  setIsScrolled: (isScrolled: boolean) => {
    set(() => ({ isScrolled }));
  },
});

export const twinSlice: StateCreator<TwinSlice> = (set) => ({
  twin: null,
  setTwin: (twin: TwinData | null) => {
    set(() => ({ twin }));
  },
});
